export function handleRequest(retailRequest, variantName, pricePromise, getGraphURL, apolloClientInfo) {
  if (retailRequest) {
    const priceApiPromises = [pricePromise(retailRequest, getGraphURL, apolloClientInfo)]

    if (variantName === 'EXPRESS') {
      const expressOWRequest = { ...retailRequest, sopq: true }
      priceApiPromises.push(pricePromise(expressOWRequest, getGraphURL, apolloClientInfo))
    }

    return Promise.all(priceApiPromises)
  }

  return Promise.resolve(null)
}
